export default __webpack_public_path__ + "static/media/preacher.1d715861.png";